module.exports = __webpack_public_path__ + "img/YXLSXT_Android.f65326f0.png";